import * as types from '@/store/spWorkerRegistration/mutationsTypes';
import { createClearPropMutation, createSetPropMutation } from '@/store/utils';

export default {
  [types.REMOVE_SP_WORKER_REGISTRATION_DATA](state) {
    state.spWorkerServicesChosen = [];
    state.spWorkerCertificationsChosen = [];
    state.spWorkerGeneralInfo = {};
    state.spWorkerAvatar = null;
  },
  [types.SET_SP_WORKER_SERVICES_CHOSEN_INFO]: createSetPropMutation('spWorkerServicesChosen'),
  [types.SET_SP_WORKER_CERTIFICATIONS_CHOSEN_INFO]: createSetPropMutation('spWorkerCertificationsChosen'),
  [types.SET_SP_WORKER_GENERAL_INFO]: createSetPropMutation('spWorkerGeneralInfo'),
  [types.SET_SP_WORKER_AVATAR]: createSetPropMutation('spWorkerAvatar'),
  [types.CLEAR_SP_WORKER_AVATAR]: createClearPropMutation('spWorkerAvatar', null),
  [types.CLEAR_SP_WORKER_CHOSEN_CERTIFICATE]: createClearPropMutation('spWorkerCertificationsChosen', []),
  [types.CLEAR_SP_WORKER_CHOSEN_SERVICES]: createClearPropMutation('spWorkerServicesChosen', []),
  [types.CLEAR_SP_WORKER_GENERAL_INFO]: createClearPropMutation('spWorkerGeneralInfo', {}),
};
